<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 



<!-- MOBILE !! --> 
<div v-if="check_mobile()" class="columns is-mobile is-multiline is-gapless has-background-white">

<div class="column is-9 is-size-6 has-text-left has-text-weight-semibold has-text-dark has-background-light ">&nbsp;{{info.cour_TITRE_F}}</div>
<div class="column is-3 is-size-7 has-text-centered has-text-weight-light has-text-dark has-background-light ">{{info.group_LANG}}&nbsp;&nbsp;{{info.sessann}}</div>

<div class="column is-8 is-size-7 has-text-left has-text-weight-light has-text-dark has-background-light ">&nbsp;{{info.prof1}}&nbsp;&nbsp;{{info.prof2}}</div>

<div class="column is-2 is-size-7 has-text-centered has-text-weight-light has-text-dark has-background-light colBorderThin">{{info.cnt}}</div>
<div class="column is-2 is-size-7 has-text-centered has-text-weight-light has-text-dark colBorderThin" :class="return_style_avg()">{{return_average(info.group_AVG)}}</div>


<div  @click="emit_click(info.group_ID,'NOTES')" class="column isLink is-3 is-size-7 has-background-light"><span class="icon"><i class="fas fa-list-ol"></i></span>NOT</div>
<div  @click="emit_click(info.group_ID,'SCHEDULE')" class="column isLink is-3 is-size-7 has-background-light"><span class="icon"><i class="fas fa-calendar-alt"></i></span>HOR</div>
<div  v-if="check_contact_access()"  @click="emit_click(info.group_ID,'CONTACT')" class="column isLink is-3 is-size-7 has-background-light"><span class="icon"><i class="fas fa-user-edit"></i></span>CON</div>
<div  class="column isLink is-3 is-size-7 has-background-light">&nbsp;</div>


</div>

 
 

 <!-- style="border-bottom: 4px solid gray;" -->
<div v-if="!check_mobile()" class="columns is-centered is-multiline is-gapless has-background-white">

 
<div @click="emit_click(info.group_ID,'NOTES')" class="column isLink is-5 colBorderThin">
<div class="columns is-multiline is-gapless">

  <div v-if="info.group_LANG=='F'" class="column is-12  is-size-5 has-text-left has-text-weight-light has-text-dark has-background-light ">&nbsp;&nbsp;{{info.cour_TITRE_F}}
        <span v-if="info.schedMain_ID > 0" class='is-pulled-right icon is-small has-text-grey-dark mt-1'><i class="fas fa-calendar"></i>&nbsp;&nbsp;</span>
  </div>
  <div v-else class="column is-12  is-size-5 has-text-left has-text-weight-light has-text-dark has-background-light ">&nbsp;&nbsp;{{info.cour_TITRE_E}}
          <span v-if="info.schedMain_ID > 0" class='is-pulled-right icon is-small has-text-grey-dark mt-1'><i class="fas fa-calendar"></i>&nbsp;&nbsp;</span>
  </div>

  <div class="column is-10  is-size-7 has-text-weight-bold has-text-left has-text-grey has-background-light ">&nbsp;&nbsp;&nbsp;{{info.cour_CODE}}</div>

<div :class="return_lang_style(info.group_LANG)" class="column is-1  has-text-centered has-text-weight-bold" style=""> {{info.group_LANG}} </div>

<div class="column is-1 has-background-dark has-text-white has-text-centered has-text-weight-bold" style=""> {{info.sessann}} </div>

 <!-- <div :class="return_lang_style(info.group_LANG)" class="column is-4  has-text-centered has-text-weight-bold" style="margin-top:-.4em;">
  <div class="columns is-gapless">
  <div class="column is-12"> {{info.group_LANG}}&nbsp;&nbsp;
  <span style="padding:10px;" :class="return_style_session(info.sessann)">  {{info.sessann}} </span>
  </div></div>
  </div> -->


</div>
</div>

<div @click="emit_click(info.group_ID,'NOTES')" class="column isLink is-3 has-background-light colBorderThin">
<div class="columns is-multiline is-gapless" style="padding-left:1em;">

<div class="column is-12 is-size-5 has-text-left has-text-weight-light has-text-dark ">{{info.prof1}}&nbsp;&nbsp;{{info.prof2}}</div>
<div style="margin-top:-.2em;" class="column is-12  is-size-7 has-text-weight-bold has-text-left has-text-grey	">{{moment(info.group_datSTART).format('ddd MMM do YYYY')}}&nbsp;&nbsp;{{moment(info.group_datEND).format('ddd MMM do YYYY')}}</div>
  <!-- <div class="column is-12  has-text-left has-text-weight-bold has-text-grey-dark	">&nbsp;&nbsp;{{moment(info.group_datEND).format('ddd MMM do YYYY')}}</div> -->
 
</div>
</div>

<!-- <span v-if="info.schedID" class="has-badge-rounded has-badge-success has-badge-large" data-badge=""></span> -->

<div @click="emit_click(info.group_ID,'NOTES')" class="column isLink colBorderThin is-1">
<div class="columns is-multiline is-gapless">
  <div class="column is-12 has-text-centered has-text-weight-bold is-size-7 has-background-light">ETUDES</div>
  <div class="column is-12 is-size-4 has-text-centered has-text-weight-bold has-text-black">{{info.cnt}}</div>
</div>
</div>

<div @click="emit_click(info.group_ID,'NOTES')" class="column isLink colBorderThin is-1" :class="return_style_avg()">
<div class="columns is-multiline is-gapless">
  <div class="column is-12 has-text-centered has-text-weight-bold is-size-7 has-background-light">AVG</div>
  <div class="column is-12 is-size-4 has-text-centered has-text-weight-bold">{{return_average(info.group_AVG)}}</div>
</div>
</div>


<!-- <div class="column is-3 has-text-centered colBorderThin has-background-light has-text-dark has-text-weight-bold">
<div class="columns is-multiline is-gapless is-centered" style="margin-top:.5em;">
  <div  @click="emit_click(info.group_ID,'NOTES')" class="column isLink is-3 is-size-7"><span class="icon"><i class="fas fa-list-ol"></i></span>NOT</div>
  <div  @click="emit_click(info.group_ID,'DETAILS')" class="column isLink is-3 is-size-7"><span class="icon"><i class="fas fa-info-circle"></i></span>DET</div>
  <div  @click="emit_click(info.group_ID,'SCHEDULE')" class="column isLink is-3 is-size-7"><span class="icon"><i class="fas fa-calendar-alt"></i></span>HOR</div>
  <div  v-if="check_contact_access()"  @click="emit_click(info.group_ID,'CONTACT')" class="column isLink is-3 is-size-7"><span class="icon"><i class="fas fa-user-edit"></i></span>CON</div>
</div>
</div> -->
    
<!--     
    <div class="column is-3  has-text-centered is-size-7 has-text-weight-bold has-background-light colBorder">CNT </div>
    <div class="column is-3  has-text-centered is-size-7 has-text-weight-bold has-background-light  colBorder">AVG
      
      
    </div>
    <div class="column is-6  has-text-centered colBorder"> {{moment(info.group_datSTART).format('MMMDD')}} - {{moment(info.group_datEND).format('MMMDD')}} </div>
    <div class="column is-3  has-text-centered colBorder">{{info.cnt}} </div>
    <div class="column is-3  has-text-centered colBorder">{{return_average(info.group_AVG)}}  </div>

    <div class="column is-6 has-text-weight-bold has-text-link has-text-centered ">&nbsp;{{info.prof1}}</div>
    <div class="column is-6 has-text-weight-bold has-text-link has-text-centered ">&nbsp;{{info.prof2}}</div> -->

<!--  -->

 
</div>


</div>
</template>



<script>
import axios from 'axios';
import moment from 'moment';

export default {
        props: [ 'info' , 'index' ],
        components: {  },

        data() {
            return {
                 students:'',
                 isLoading:false,
            }
        },

created() {

},


methods: {


check_mobile() {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return true} else {return false} 
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return sizeM} else {return sizeD} 
},

check_contact_access:function() {
// CHECK IF COLLEGE CAN EMAIL/SMS
    if (sessionStorage.getItem('college_canEMAIL') || sessionStorage.getItem('college_canSMS'))
    {return true}
    else {return false}
},

emit_click:function(gID, view) {
  this.$emit('emitTheClick', gID, this.index , view)
},


return_average:function(avg) {
  
  if (avg == 'null') { return ''}
  if (!avg) { return ''}
  if(isNaN(avg)) { return ''}
  if (avg == 0 ) {return '-'}
  return avg + '%'

},


return_style_session:function(session) {
// RETURN THE STYLE OF THE SESSION

return 'has-background-dark has-text-white'

  // if (session.charAt(0) == "E") {return 'has-background-success has-text-dark'}
  // else if (session.charAt(0) == "A") {return 'has-background-warning has-text-dark'}
  // else {return 'has-background-dark has-text-white'}

},


return_lang_style:function(lang) {
  if (lang == "F") {
    return 'has-background-link has-text-white' //'background-color:#95BBCC;'
  } else {
    return 'has-background-danger has-text-white' //'background-color:#FFD3DA;'
  }
}, // END RETURN LANG STYLE


return_style_avg:function() {
    if (this.info.group_PUBLIC) {
        return 'has-background-success has-text-white' //'background-color:#8FBC8B;'
    } else {
        var dtNow = moment()
        var dtSTART = moment(this.info.group_datSTART)
        var dtEND = moment(this.info.group_datEND)

        if (dtNow > dtSTART) {
            return 'has-background-warning has-text-dark' //'background-color:#F0E68C;'
        }
    }
},



}, // END METHODS



} // END EXPORT
</script>




<style scoped>

select {
  text-align: center;
  text-align-last: center;
  font-weight: 900;
  /* webkit*/
}
option {
  text-align: left;
  /* reset to left*/
}

</style>